export const twitterSvg = (
  <svg
    data-testid="ock-twitterSvg"
    role="img"
    aria-label="ock-twitterSvg"
    width="100%"
    height="100%"
    viewBox="-1 -1 14 14"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="h-full w-full"
  >
    <g clipPath="url(#clip0_6998_47)">
      <path
        d="M7.14163 5.07857L11.6089 0H10.5503L6.67137 4.40965L3.57328 0H0L4.68492 6.66817L0 11.9938H1.05866L5.15491 7.33709L8.42672 11.9938H12L7.14137 5.07857H7.14163ZM5.69165 6.72692L5.21697 6.06292L1.44011 0.779407H3.06615L6.11412 5.04337L6.5888 5.70737L10.5508 11.2499H8.92476L5.69165 6.72718V6.72692Z"
        className="fill-ock-foreground"
      />
    </g>
    <defs>
      <clipPath id="clip0_6998_47">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
